import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../app/auth/authSlice";
import authService from "../../services/authService";
import "./sidebar-user-menu.css";

function firstWord(value) {
  return String(value || "").trim().split(/\s+/)[0] || "";
}

function lastInitial(value) {
  const last = String(value || "").trim();
  if (!last) return "";
  return `${last.charAt(0).toUpperCase()}.`;
}

/** Display: "Mathew R." — first name + last initial */
function formatDisplayName(user, profileData) {
  const ud = user?.userData || {};
  const first =
    firstWord(ud.firstName) ||
    firstWord(ud.FirstName) ||
    firstWord(profileData?.ownerName) ||
    firstWord(profileData?.OwnerName) ||
    "User";
  const initial =
    lastInitial(ud.lastName) ||
    lastInitial(ud.LastName) ||
    "";
  return initial ? `${first} ${initial}` : first;
}

function resolveAvatar(user, profileData) {
  const ud = user?.userData || {};
  return (
    ud.staffImage ||
    ud.StaffImage ||
    profileData?.compIcon ||
    profileData?.CompIcon ||
    "/assets/img/serveiq.png"
  );
}

function SidebarUserMenu() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const profileData = useSelector((state) => state.auth.profileData);
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const displayName = formatDisplayName(user, profileData);
  const avatarSrc = resolveAvatar(user, profileData);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const handleLogout = async () => {
    setOpen(false);
    await authService.logout();
    dispatch(logout());
    setTimeout(() => {
      navigate("/user/login", { replace: true });
    }, 0);
  };

  return (
    <div className="sidebar-user-menu" ref={rootRef}>
      <button
        type="button"
        className={`sidebar-user-menu__trigger${open ? " is-open" : ""}`}
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="sidebar-user-menu__avatar-wrap">
          <img
            className="sidebar-user-menu__avatar"
            src={avatarSrc}
            alt=""
            onError={(e) => {
              e.currentTarget.src = "/assets/img/serveiq.png";
            }}
          />
        </span>
        <span className="sidebar-user-menu__name">{displayName}</span>
        <i
          className={`fa sidebar-user-menu__caret ${
            open ? "fa-chevron-up" : "fa-chevron-down"
          }`}
          aria-hidden="true"
        />
      </button>

      {open ? (
        <div className="sidebar-user-menu__dropdown" role="menu">
          <Link
            to="/profile"
            className="sidebar-user-menu__item"
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            <i className="fa fa-user" aria-hidden="true" />
            Profile
          </Link>
          <button
            type="button"
            className="sidebar-user-menu__item sidebar-user-menu__item--danger"
            role="menuitem"
            onClick={handleLogout}
          >
            <i className="fa fa-sign-out-alt" aria-hidden="true" />
            Log Out
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default SidebarUserMenu;
